module.exports = __webpack_public_path__ + "assets/webgl/ConcreteFloor_Normal.66766058.jpg";